module.exports = __webpack_public_path__ + "static/media/ef2bhk.03164e86.jpg";